import React from 'react';
import './ToggleSwitch.css';

const ToggleSwitch = ({ onChange, checked, label = '' }) => {
  return (
    <div className="d-inline-flex align-items-center" style={{ verticalAlign: 'middle', lineHeight: 1 }}>
      <label className="switch m-0" style={{ verticalAlign: 'middle', display: 'inline-block' }}>
        <input type="checkbox" checked={Boolean(checked)} onChange={onChange} />
        <span className="slider round"></span>
      </label>
      {label ? <span className="ms-1" style={{ fontSize: '11px', fontWeight: '600', color: '#475569', whiteSpace: 'nowrap' }}>{label}</span> : null}
    </div>
  );
};

export default ToggleSwitch;
